import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { metaReducers, ROOT_REDUCER_TOKEN, runtimeChecks } from './configurations/store.config';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthEffects } from './store/effects/auth.effects';
import { ApplicationEffects } from './store/effects/application.effects';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';
import { LogService } from './services/log.service';
import { LogPublishersService } from './services/log-publishers.service';
import { ConfirmationService } from 'primeng/api';
import { ApiInterceptor } from './interceptors';
import { ClaimsEffects } from './store/effects/claims.effects';
import { AccountsEffects } from './store/effects/accounts.effects';
import { SitesEffects } from './store/effects/sites.effects';
import { UserPreferencesEffects } from './store/effects/user-preferences.effects';
import { NotApplicableCriteriaEffects } from './store/effects/not-applicable-criteria.effects';
import { FiltersEffects } from './store/effects/filters.effects';
import { CIRuleActionsEffects } from './store/effects/ci-rule-actions.effects';
import { provideApollo } from 'apollo-angular';
import { createApollo } from './configurations/graphql.config';
import { PERIOD_OPTIONS, PERIOD_OPTIONS_TOKEN } from '../shared/constants/period-options.config';
import { EApplicationEnvironments } from './configurations/application.config';
import { AccountSitesEffects } from './store/effects/account-sites.effects';
import { ReportViewsEffects } from './store/effects/report-views.effects';
import { ScorecardsEffects } from './store/effects/scorecards.effects';

const storeModules = [
  StoreModule.forRoot(ROOT_REDUCER_TOKEN, { metaReducers, runtimeChecks }),
  StoreDevtoolsModule.instrument({
    maxAge: 25,
    logOnly: environment.application_environment === EApplicationEnvironments.production,
    connectInZone: true,
  }),
  EffectsModule.forRoot([
    AuthEffects,
    ApplicationEffects,
    FiltersEffects,
    ClaimsEffects,
    AccountsEffects,
    SitesEffects,
    ScorecardsEffects,
    UserPreferencesEffects,
    NotApplicableCriteriaEffects,
    CIRuleActionsEffects,
    AccountSitesEffects,
    ReportViewsEffects,
  ]),
  StoreRouterConnectingModule.forRoot(),
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    OAuthModule.forRoot({
      resourceServer: {
        sendAccessToken: true,
        customUrlValidation: (url) =>
          url.startsWith('/api/') ||
          url.startsWith(environment.reporting_api_url) ||
          (environment.log_endpoint && url.startsWith(environment.log_endpoint)) ||
          url.startsWith(environment.sitemanagement_api_url) ||
          url.startsWith(environment.graphql_url) ||
          url.startsWith(environment.scorecards_api_url) ||
          url.startsWith(environment.conversation_api_url) ||
          url.startsWith(environment.agent_call_management_api_url) ||
          url.startsWith(environment.lh_api_url) ||
          url.startsWith(environment.ace_vla_url),
      },
    }),
    ...storeModules,
  ],
  providers: [
    LogService,
    LogPublishersService,
    ConfirmationService,
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    { provide: OAuthStorage, useValue: localStorage },
    { provide: Window, useValue: window },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: PERIOD_OPTIONS_TOKEN, useValue: PERIOD_OPTIONS },
    provideApollo(createApollo),
  ],
})
export class CoreModule {}
